module.exports = __webpack_public_path__ + "img/MCS_Logos_RU.8daceab1.png";